import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { DatePipe } from "@angular/common";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from 'ag-grid-community';

type IDateCellValueTypes = string | Date | undefined | null;
type IDateCellParams = ICellRendererParams<unknown, IDateCellValueTypes> & {
  dateTemplate: string | undefined | null;
};

@Component({
  selector: 'app-ag-date-cell',
  standalone: true,
  imports: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="date-cell">
      {{ (date() | date: dateTemplate()) || '-' }}
    </div>
  `,
})
export class AgDateCellComponent implements ICellRendererAngularComp {
  readonly defaultDateTemplate = 'dd MMM yyyy';

  date = signal<IDateCellValueTypes>(null);
  dateTemplate = signal<string>(this.defaultDateTemplate);

  agInit(params: IDateCellParams): void {
    this.updateCell(params);
  }

  refresh(params: IDateCellParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: IDateCellParams): boolean {
    this.date.set(params.value);
    this.dateTemplate.set(params.dateTemplate ?? this.defaultDateTemplate);
    return true;
  }
}
